import React, { Component } from 'react';
import './styles.css';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import arrow from '../../../../../assets/icons/leftArrow.png';


class BreadCrumb extends Component {
    render() {
        const { currentResort } = this.props;
        return (
            <div className="breadcrumb">
                <Link to="/" style={{marginLeft:-7}}>
                <IconButton aria-label="add" color="primary" size="small">
                   <img src={arrow} alt="goBack" width={30} style={{padding:5}}/>
                </IconButton>
                </Link>
                
                <p className="titleBread">{currentResort && currentResort.name}</p>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    currentResort: state.ResortsReducer.currentResort,
});

const mapDispatchToProps = dispatch => ({

});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(BreadCrumb);